{
  "3FEEDE53-20B7-DEE8-C64B-8D0738E667A9": "undead",
  "FE5CD056-4302-EBB7-BAE4-E8BC0CCC1FCD": "plant",
  "01671C87-2DB5-B7C0-6312-FCCD4C20C128": "ooze",
  "0D7FEDA8-DC2A-6048-5C13-73219F1F0B4F": "monstrosity",
  "3A28EC64-DA47-09A0-AD1B-31B32627094F": "humanoid",
  "D1429E13-BDC0-8D8A-011A-522DF622FA2C": "giant",
  "208CF3F2-DE5C-77BC-21D5-3654094FE435": "fiend",
  "492112D6-F574-43B2-9DFE-C37FE82A0763": "fey",
  "D3E7CACD-C46B-1C27-39BC-3E4803D6AED5": "elemental",
  "88D96DCB-894B-F4B2-7EEE-4306D63566F2": "dragon",
  "BAF03D85-934E-4781-7C5F-26EE18BC8614": "construct",
  "5169158E-D7ED-A3E6-7627-A934EBBD9CAD": "celestial",
  "68B30308-92E2-38A9-E73B-5CA95EBFD424": "beast",
  "EDD2EF50-DC2D-75F3-367F-A6A9D63D9316": "aberration"
}
